import { z } from "zod";

export const AppStartupSliceSchema = z.object({
    userId: z.uuid().nullable(),
    generation: z.number().int().nonnegative(),
    initialSurfaceReadyAt: z.number().nullable(),
    gnomeNavigationAt: z.number().nullable(),
    gnomePreloadMode: z.enum(["off", "bytes", "prepare"]),
});
export type AppStartupSlice = z.infer<typeof AppStartupSliceSchema>;
